import React from 'react'
import PropTypes from 'prop-types'
import { LogosArea } from 'LiveBoard/components/shared/LogosArea'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import ShareBoardContainer from 'LiveBoard/containers/ShareBoardContainer'
import { ShareBoard } from '../ShareBoard'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'
import { Banner, BANNER_TYPES } from 'LiveBoard/components/shared/Banner'
import includes from 'lodash/includes'

import './style.css.scss'

const Header = (props) => {

  const {boardId, config, themeColorHex, textColor, banner} = props

  const solidBackground = (
    config.background.show ||
    (!!banner && (!banner.show || banner.height == BANNER_TYPES.basic))
  )

  return (
    <section
      className={`${LIVE_BOARD_CLASSNAMES.header} ${config.background.show ? 'solid' : ''}`}
      style={{ color: textColor }}>
      { props.isClassicItemView && props.isGatingFormOpened &&
          <div className='header-overlay'></div>
      }
      {
        !!banner && !solidBackground && (
          <div className='header-banner-wrapper'>
            <Banner
              config={banner}
              themeColorHex={themeColorHex}
              showContent={false} />
          </div>
        )
      }
      <div className='header-content'>
        <LogosArea config={{ logo: config.logo, icon: config.icon, secondaryLogo: config.secondary_logo}}/>
        <h2>{config.tagline.text}</h2>
        <div className="right-content">
          { config.cta.show && (
            <CallToActionContainer
              config={{...config.cta}}
              area={CTA_AREAS.header}
              themeColorHex={themeColorHex} />
          )}
          { includes(config.social, true) &&
            <ShareBoardContainer
              component={ShareBoard}
              boardId={boardId}
              config={config.social}
              themeColorHex={themeColorHex}
              textColor={textColor} />
          }
        </div>
      </div>
    </section>
  )
}

Header.propTypes = {
  boardId: PropTypes.number.isRequired,
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  isGatingFormOpened: PropTypes.bool.isRequired,
  isClassicItemView: PropTypes.bool.isRequired
}

export default Header